<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span class="cur">选择支付方式</span>
        <span>购买成功</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情</h3>
        <ul class="column4">
          <li>
            <div>产品名称</div>
            <div>订单编号</div>
            <div>数量</div>
            <div>小计</div>
          </li>
          <li>
            <div>
              <p>{{orderInfo.goodsName}}</p>
            </div>
            <div>{{orderInfo.orderId}}</div>
            <div>1/{{stockUnit}}</div>
            <div>￥{{orderInfo.payAmount}}元</div>
          </li>
        </ul>
        <div class="totalLine">
          <div class="note-r" v-if="!orderInfo.paidMoney">
            <p class="totalMoney">
              <span>支付金额总计：</span>
              <strong>{{orderInfo.payAmount}}</strong>
              <em>元</em>
            </p>
            <p>
              <span>已优惠：</span>
              <em>{{orderInfo.oriPrice - orderInfo.payAmount}} 元</em>
            </p>
          </div>
          <div class="note-r" v-else>
            <p class="totalMoney">
              <span>剩余待支付金额：</span>
              <strong>{{orderInfo.payMoney - orderInfo.paidMoney}}</strong>
              <em>元</em>
            </p>
          </div>
        </div>
      </div>
      <div class="mod pr">
        <h3 class="title">支付方式</h3>
        <div class="nav-pay clearfix">
          <span @click="selectPayModeOuter(11,0)" :class="{cur : payIndex == 0}">支付宝</span>
        </div>
        <div class="pay-con">
          <div class="bank-list" v-show="payIndex === 0">
            <span
              v-for="(item, index) in mainPay"
              :key="item.id"
              :class="{cur: index === bankIndex}"
              @click="selectPayModeInner(item.payMode, index)"
            >
              <img :src="require('@/assets/images/bank/' + item.imgName)" />
            </span>
          </div>
        </div>
        <p class="pay-info">
          如遇到支付问题，可随时拨打
          <em>021-20219997</em>，客服将第一时间帮你解决
        </p>
        <a class="btn-normal" @click="orderPay">确认订单</a>
      </div>
    </div>
    <!-- <app-footer /> -->
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
// import AppFooter from "@/components/common/AppFooter.vue";
import payData from "@/assets/paybank.json";
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      payMoney: "",
      payMode: 11, //默认支付宝
      bankCode: "",
      orderInfo: {},
      payActive: false,
      payIndex: 0,
      bankIndex: 0,
      selectedText: "更多",
      mainPay: payData.mainPay,
      unionPayB2C: payData.unionPayB2C,
      unionPayOnline: payData.unionPayOnline,
      bill99Pay: payData.bill99Pay,
      transPay: payData.transPay,
      orderPayAble: true,
      productId: '',
      stockUnit: ''
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.$get("/order/v1/queryById?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data.orderDetailList[0];
            this.productId = response.data.productId;
            this.stockUnit = response.data.stockUnit
            if (this.orderInfo.paidMoney > 0) {
              this.selectPayModeOuter(26,2);
            }
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    selectPayModeOuter(payMode, payIndex) {
      if (payMode == 27 || payMode == 7) {
        this.bankCode = "ABC";
      }
      if (payMode == 3) {
        this.bankCode = "ICBC";
      }
      this.payActive = false;
      this.payMode = payMode;
      this.payIndex = payIndex;
      this.bankIndex = 0;
    },
    selectBank(bankCode, bankIndex) {
      this.bankCode = bankCode;
      this.bankIndex = bankIndex;
    },
    selectPayModeInner(payMode, bankIndex) {
      if (payMode == 26) {
        this.payMoney = '';
      }
      this.payMode = payMode;
      this.bankIndex = bankIndex;
    },
    selectMore(e, payMode, payIndex) {
      this.payActive = false;
      this.selectedText = e.target.innerText;
      this.selectPayModeOuter(payMode, payIndex);
    },
    orderPay() {
      if (!this.payMode) {
        this.$alert("请选择您的支付方式", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      if (this.payMode === 3) {
        // 跳转转账页面
        this.$router.push("/pay/trans/" + this.orderId+"/1/"+this.bankCode);
        return false;
      }
      if (this.payMode === 23) {
        if (this.orderInfo.paidMoney) {
          this.payMode = 26;
        } else {
          // 跳转二维码支付页面
          this.$router.push("/pay/qrcode/" + this.orderId + "/" + this.payMode);
          return false;
        }
      }
      // web支付页面
      if (!this.orderPayAble) {
        return false;
      }
      var params = {
        orderId: this.orderId,
        payMode: this.payMode
      };
      if (this.payMode == 27 || this.payMode == 7) {
        params.bankCode = this.bankCode;
      }
      if (this.payMoney) {
        params.payMoney = this.payMoney;
      }
      this.orderPayAble = false;
      this.$get("pay/v1/web", params)
        .then(response => {
          console.log(response)
          if (response.code === 0) {
            window.location.href = response.data;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
          this.orderPayAble = true;
        })
        .catch(err => {
          this.orderPayAble = true;
          this.$global.alertError();
        });
    }
  },
  components: {
    AppHeader,
    // AppFooter
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.orderInfo>ul>li:nth-child(2)>div .giftName{width: 250px;}
.icon-checked {
  background-image: url(~@/assets/images/icon/right.png);
  background-size: 14px auto;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-color: #166eff;
  cursor: pointer;
}
.orderInfo {
  .column4 {
    li {
      > div {
        &:first-child {
          width: 280px;
        }
        &:nth-child(2) {
          width: 230px;
        }
        &:nth-child(3) {
          width: 270px;
        }
      }
      &:nth-child(2) {
        > div {
          &:last-child {
            @include fc(20px, #222);
          }
        }
      }
    }
  }
}
.dispatch-list {
  li {
    @include fc(16px, #666);
    margin-bottom: 12px;
  }
}
.nav-pay {
  span {
    padding: 0 16px;
    @include line-height(40px);
    border: 1px solid #e5e5e5;
    border-right: 0;
    background: #fff;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
    &.cur {
      background: #fbfbfb;
      border-top: 2px solid #166fff;
      border-bottom: 1px solid #fbfbfb;
    }
  }
  .select {
    float: left;
    position: relative;
    .selected {
      position: relative;
      .icon-selectBtn {
        border-left: 0;
        height: 40px;
      }
      span {
        width: 120px;
        border-right: 1px solid #e5e5e5;
      }
    }
    .optionList {
      width: 118px;
      top: 40px;
      li {
        text-indent: 0;
        text-align: center;
      }
    }
  }
}
.pay-con {
  margin: -1px 0 70px 0;
  width: 100%;
  box-sizing: border-box;
  background: rgba(216, 216, 216, 0.1);
  padding: 30px 15px;
  border: 1px solid #e5e5e5;
  > .bank-list {
    &:first-child {
      img {
        height: 58px;
      }
    }
  }
  .bank-list {
    & > span {
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 1.96px;
      @include wh(167px, 60px);
      text-align: center;
      display: inline-block;
      margin: 0 15px 15px 0;
      line-height: 60px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      cursor: pointer;
      img {
        vertical-align: middle;
      }
      &.cur {
        border: 1px solid #166fff;
        position: relative;
        &:after {
          content: "";
          display: inline-block;
          @extend .icon-checked;
          background-repeat: no-repeat;
          background-position: center center;
          position: absolute;
          right: -1px;
          bottom: -1px;
          margin-right: 0;
        }
      }
    }
  }
  .unionPayOnline {
    .bank-list {
      float: left;
    }
    .unionPayOnline-r {
      margin-left: 400px;
      border-left: 1px solid #dbdbdb;
      padding: 0px 30px 5px;
      p {
        @include fc(14px, #666);
        line-height: 22px;
        margin-bottom: 10px;
      }
      input {
        border: 1px solid #dbdbdb;
        line-height: 24px;
        width: 110px;
        margin-right: 5px;
        padding-left: 10px;
      }
    }
  }
}
.pay-info {
  @include fc(14px, #666);
  padding-bottom: 45px;
  em {
    color: #166fff;
  }
}
.btn-normal {
  bottom: 40px;
    &:hover{
    background: #1460db;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderPay.vue